import iframeResize from 'iframe-resizer/js/iframeResizer';

export const ifrResize = {
    beforeMount( el, { value = {} }) {
        el.addEventListener('load', () => iframeResize(value, el))
    },
    unmounted(el) {
        el.iFrameResizer.removeListeners();
      }
}